import { createContext } from "react";
import type {
  CopyKey,
  DataValueKind,
  Language
} from "./lib/localization";

export interface I18nValue {
  language: Language;
  locale: string;
  t: (key: CopyKey) => string;
  localize: (value: string | null | undefined, kind: DataValueKind) => string;
  toggleLanguage: () => void;
}

export const I18nContext = createContext<I18nValue | null>(null);
